let depCalc = () => {
  let sumElem = document.querySelector('#depCalcSum'),
      dayElem = document.querySelector('#depCalcDay'),
      resultElem = document.querySelector('#depCalcResult'),
      result;

  result = Number(sumElem.innerHTML) + Number(sumElem.innerHTML) * 5.01 * Number(dayElem.innerHTML) / 365 / 100;
  resultElem.innerHTML = result.toFixed(2);
};

module.exports = depCalc;
